import React from 'react';
import AnimatedNumber from 'react-animated-number';
import classnames from 'classnames';
import { useStyles } from './styles';

const handleBtnEnter = fn => e => {
  if (e.key === 'Enter') {
    fn(e);
  }
};

export default function LoanAmountFilter({ children }) {
  const classes = useStyles();
  return <div className={classes.root}>{children}</div>;
}

export function CirclePlusIcon({ onClick, onKeyPress, ref = undefined, disabled }) {
  const classes = useStyles();
  return (
    <div
      className={classnames(classes.circleIcon, 'BAUILoanAmountFilter-plus', {
        'BAUILoanAmountFilter-plus--disabled': disabled,
        [classes.circleIconDisabled]: disabled,
      })}
      id="loan-amount-filter-plus"
      onClick={onClick}
      onKeyDown={handleBtnEnter(onKeyPress)}
      ref={ref}
      role="button"
      aria-disabled={!!disabled}
      aria-label="Increase loan amount"
      tabIndex={0}
      data-qa-id="amount-filter-plus"
      data-nid-target="plusSignAmountFilter"
    />
  );
}

export function CircleMinusIcon({ onClick, onKeyPress, ref = undefined, disabled }) {
  const classes = useStyles();
  return (
    <div
      className={classnames(classes.circleIcon, 'BAUILoanAmountFilter-minus', {
        'BAUILoanAmountFilter-minus--disabled': disabled,
        [classes.circleIconDisabled]: disabled,
      })}
      id="loan-amount-filter-minus"
      onClick={onClick}
      onKeyDown={handleBtnEnter(onKeyPress)}
      ref={ref}
      role="button"
      aria-disabled={Boolean(disabled)}
      aria-label="Decrease loan amount"
      tabIndex={0}
      data-qa-id="amount-filter-minus"
      data-nid-target="minusSignAmountFilter"
    />
  );
}

function ContentTitle({ children }) {
  const classes = useStyles();
  return (
    <div className={classes.title} data-qa-id="amount-filter-title">
      <h4>{children}</h4>
    </div>
  );
}

function ContentAmount({ amount, formatter, duration = 500, stepPrecision = 0 }) {
  const classes = useStyles();
  return (
    <div className={classes.amount} data-qa-id="amount-filter-amount">
      <AnimatedNumber
        initialValue={amount}
        value={amount}
        duration={duration}
        formatValue={formatter}
        stepPrecision={stepPrecision}
      />
    </div>
  );
}

function ContentDescription({ children }) {
  const classes = useStyles();
  return (
    <div className={classes.desc} data-qa-id="amount-filter-description">
      {children}
    </div>
  );
}

function ContentBody({ children }) {
  const classes = useStyles();
  return <div className={classes.content}>{children}</div>;
}

export const Content = {
  Root: ContentBody,
  Title: ContentTitle,
  Amount: ContentAmount,
  Description: ContentDescription,
};

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/shared_modules/baui-ui/components/LoanAmountFilter/LoanAmountFilter.scss');
require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/shared_modules/baui-ui/components/LoanAmountFilter/images/minus-sky-900.svg');
require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/shared_modules/baui-ui/components/LoanAmountFilter/images/minus-stainless-500.svg');
require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/shared_modules/baui-ui/components/LoanAmountFilter/images/plus-sky-900.svg');
require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/shared_modules/baui-ui/components/LoanAmountFilter/images/plus-stainless-500.svg');